// ============================
// FrmAnimalLista.jsx (FIX FINAL + PESO)
// ============================

import React, { useEffect, useState } from "react";
import { Table, Input, Select, Button, Space, Tag, Row, Col, Card } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;
const { Option } = Select;

const FrmAnimalLista = () => {
  const navigate = useNavigate();

  const [animales, setAnimales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);

  // Filtros
  const [texto, setTexto] = useState("");
  const [sexo, setSexo] = useState(undefined);
  const [estado, setEstado] = useState(undefined);
  const [especie, setEspecie] = useState(undefined);

  // Paginación
  const [pagina, setPagina] = useState(1);
  const [tamanoPagina, setTamanoPagina] = useState(10);

  // ============================
  // Cargar datos
  // ============================
  const cargarAnimales = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${API_URL}/Animal`, {
        params: {
          texto,
          sexo,
          estado,
          especie,
          pagina,
          tamañoPagina: tamanoPagina,
        },
      });

      const lista = Array.isArray(response.data.lista?.$values)
        ? response.data.lista.$values
        : [];

      const total = response.data.total ?? 0;

      setAnimales(lista);
      setTotalRegistros(total);
    } catch (error) {
      console.error("Error cargando animales:", error);
      setAnimales([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarAnimales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [texto, sexo, estado, especie, pagina, tamanoPagina]);

  // ============================
  // Columnas
  // ============================
  const columnas = [
    {
      title: "Arete",
      dataIndex: "arete",
      key: "arete",
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Especie",
      dataIndex: "especie",
      key: "especie",
      render: (v) => v || "Bovino",
      responsive: ["sm", "md", "lg"],
    },
    {
      title: "Raza",
      dataIndex: "razaNombre",
      key: "razaNombre",
      render: (value) => value || "-",
      responsive: ["sm", "md", "lg"],
    },
    {
      title: "Peso (kg)",
      dataIndex: "pesoActual",
      key: "pesoActual",
      align: "right",
      render: (peso) =>
        peso !== null && peso !== undefined ? `${peso} kg` : "-",
    },
    {
      title: "Sexo",
      dataIndex: "sexo",
      key: "sexo",
      render: (sexo) =>
        sexo === "Hembra" ? (
          <Tag color="magenta">Hembra</Tag>
        ) : (
          <Tag color="blue">Macho</Tag>
        ),
    },
    {
      title: "Partos",
      dataIndex: "totalPartos",
      key: "totalPartos",
      align: "center",
    },

    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      render: (estado) => (
        <Tag
          color={
            estado === "Activo"
              ? "green"
              : estado === "Transferido"
              ? "orange"
              : estado === "Vendido"
              ? "blue"
              : "red"
          }
        >
          {estado}
        </Tag>
      ),
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            onClick={() =>
              navigate(`/dashboard/ganado/animales/${record.id}`)
            }
          >
            Ver
          </Button>
          <Button
            type="link"
            onClick={() =>
              navigate(`/dashboard/ganado/animales/${record.id}/editar`)
            }
          >
            Editar
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 16 }}>
      <Card bordered style={{ marginBottom: 20 }}>
        <h2>Listado de Animales</h2>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Input
              placeholder="Buscar por Arete o Nombre"
              prefix={<SearchOutlined />}
              value={texto}
              onChange={(e) => {
                setPagina(1);
                setTexto(e.target.value);
              }}
              allowClear
            />
          </Col>

          <Col xs={12} sm={6} md={4} lg={4}>
            <Select
              placeholder="Sexo"
              value={sexo}
              onChange={(v) => {
                setPagina(1);
                setSexo(v);
              }}
              allowClear
              style={{ width: "100%" }}
            >
              <Option value="Macho">Macho</Option>
              <Option value="Hembra">Hembra</Option>
            </Select>
          </Col>

          <Col xs={12} sm={6} md={4} lg={4}>
            <Select
              placeholder="Estado"
              value={estado}
              onChange={(v) => { setPagina(1); setEstado(v); }}
              allowClear
              style={{ width: "100%" }}
            >
              <Option value="Activo">Activo</Option>
              <Option value="Vendido">Vendido</Option>
              <Option value="Muerto">Muerto</Option>
              <Option value="Transferido">Transferido</Option>
            </Select>
          </Col>

          <Col xs={12} sm={6} md={4} lg={4}>
            <Select
              placeholder="Especie"
              value={especie}
              onChange={(v) => { setPagina(1); setEspecie(v); }}
              allowClear
              style={{ width: "100%" }}
            >
              <Option value="Bovino">Bovino</Option>
              <Option value="Aviar">Aviar</Option>
              <Option value="Canino">Canino</Option>
            </Select>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6}>
            <Button
              type="primary"
              onClick={() => navigate("/dashboard/ganado/animales/nuevo")}
            >
              Nuevo Animal
            </Button>
          </Col>
        </Row>
      </Card>

      <Table
        columns={columnas}
        dataSource={animales}
        loading={loading}
        rowKey="id"
        scroll={{ x: 900 }}
        pagination={{
          current: pagina,
          pageSize: tamanoPagina,
          total: totalRegistros,
          onChange: (p, s) => {
            setPagina(p);
            setTamanoPagina(s);
          },
          showSizeChanger: true,
        }}
      />
    </div>
  );
};

export default FrmAnimalLista;
